/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { BodyPaymentAttemptResolutionResponse } from '../_model/bodyPaymentAttemptResolutionResponse';
import type { BodyQuizPlanOrderResolutionResponse } from '../_model/bodyQuizPlanOrderResolutionResponse';
import type { CreateQuizPlanOrderRequest } from '../_model/createQuizPlanOrderRequest';
import type { GenerateOrderIdParams } from '../_model/generateOrderIdParams';
import type { GetPaymentStatusParams } from '../_model/getPaymentStatusParams';
import type { GetQuizPlanOrderParams } from '../_model/getQuizPlanOrderParams';
import type { HandlePaymentSuccessParams } from '../_model/handlePaymentSuccessParams';
import type { PlanChangeOrderRequest } from '../_model/planChangeOrderRequest';
import type { PlanChangeQuoteRequest } from '../_model/planChangeQuoteRequest';
import type { PlanQuoteRequest } from '../_model/planQuoteRequest';
import type { PriceCalculationRequest } from '../_model/priceCalculationRequest';
import type { RecordPaymentPendingRequest } from '../_model/recordPaymentPendingRequest';
import type { ResolvePaymentAttemptParams } from '../_model/resolvePaymentAttemptParams';
import type { SuccessBodyGetUserPlanAvailabilityResponse } from '../_model/successBodyGetUserPlanAvailabilityResponse';
import type { SuccessBodyPaymentStatusResponse } from '../_model/successBodyPaymentStatusResponse';
import type { SuccessBodyPlanChangeQuoteResponse } from '../_model/successBodyPlanChangeQuoteResponse';
import type { SuccessBodyPlanQuoteResponse } from '../_model/successBodyPlanQuoteResponse';
import type { SuccessBodyPriceCalculationResponse } from '../_model/successBodyPriceCalculationResponse';
import type { SuccessBodyQuizPlanOrderResponse } from '../_model/successBodyQuizPlanOrderResponse';
import type { SuccessBodyQuizPlanPaymentResponse } from '../_model/successBodyQuizPlanPaymentResponse';
import type { SuccessBodyString } from '../_model/successBodyString';
import type { SuccessBodyUnit } from '../_model/successBodyUnit';
import type { TossWebhookEvent } from '../_model/tossWebhookEvent';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * PAYMENT_STATUS_CHANGED, CANCEL_STATUS_CHANGED 이벤트를 처리합니다. 결제 상태 웹훅은 서버 주문의 Antom route/amount/currency 와 대조한 뒤 반영합니다.
 * @summary Toss webhook 수신
 */
export const handleTossWebhook = (
  tossWebhookEvent: BodyType<TossWebhookEvent>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyUnit>(
    {
      url: `/webhooks/tosspayments/quiz-plan-payments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tossWebhookEvent,
      signal,
    },
    options,
  );
};

export const getHandleTossWebhookMutationKey = () =>
  ['handleTossWebhook'] as const;

export const getHandleTossWebhookMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTossWebhook>>,
    TError,
    HandleTossWebhookMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleTossWebhook>>,
  TError,
  HandleTossWebhookMutationVariables,
  TContext
> => {
  const mutationKey = getHandleTossWebhookMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleTossWebhook>>,
    HandleTossWebhookMutationVariables
  > = props => {
    const { data } = props ?? {};

    return handleTossWebhook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleTossWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleTossWebhook>>
>;
export type HandleTossWebhookMutationBody = BodyType<TossWebhookEvent>;
export type HandleTossWebhookMutationError = ErrorType<unknown>;
export type HandleTossWebhookMutationVariables = {
  data: BodyType<TossWebhookEvent>;
};

/**
 * @summary Toss webhook 수신
 */
export const useHandleTossWebhook = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof handleTossWebhook>>,
      TError,
      HandleTossWebhookMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof handleTossWebhook>>,
  TError,
  HandleTossWebhookMutationVariables,
  TContext
> => {
  return useMutation(getHandleTossWebhookMutationOptions(options), queryClient);
};
export const resolveQuizPlanOrder = (
  createQuizPlanOrderRequest: BodyType<CreateQuizPlanOrderRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<BodyQuizPlanOrderResolutionResponse>(
    {
      url: `/quiz-plans/payment/resolve-order`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createQuizPlanOrderRequest,
      signal,
    },
    options,
  );
};

export const getResolveQuizPlanOrderMutationKey = () =>
  ['resolveQuizPlanOrder'] as const;

export const getResolveQuizPlanOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveQuizPlanOrder>>,
    TError,
    ResolveQuizPlanOrderMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveQuizPlanOrder>>,
  TError,
  ResolveQuizPlanOrderMutationVariables,
  TContext
> => {
  const mutationKey = getResolveQuizPlanOrderMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveQuizPlanOrder>>,
    ResolveQuizPlanOrderMutationVariables
  > = props => {
    const { data } = props ?? {};

    return resolveQuizPlanOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveQuizPlanOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveQuizPlanOrder>>
>;
export type ResolveQuizPlanOrderMutationBody =
  BodyType<CreateQuizPlanOrderRequest>;
export type ResolveQuizPlanOrderMutationError = ErrorType<unknown>;
export type ResolveQuizPlanOrderMutationVariables = {
  data: BodyType<CreateQuizPlanOrderRequest>;
};

export const useResolveQuizPlanOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resolveQuizPlanOrder>>,
      TError,
      ResolveQuizPlanOrderMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resolveQuizPlanOrder>>,
  TError,
  ResolveQuizPlanOrderMutationVariables,
  TContext
> => {
  return useMutation(
    getResolveQuizPlanOrderMutationOptions(options),
    queryClient,
  );
};
export const resolvePlanChangeOrder = (
  planChangeOrderRequest: BodyType<PlanChangeOrderRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<BodyQuizPlanOrderResolutionResponse>(
    {
      url: `/quiz-plans/payment/resolve-order/plan-change`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: planChangeOrderRequest,
      signal,
    },
    options,
  );
};

export const getResolvePlanChangeOrderMutationKey = () =>
  ['resolvePlanChangeOrder'] as const;

export const getResolvePlanChangeOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolvePlanChangeOrder>>,
    TError,
    ResolvePlanChangeOrderMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolvePlanChangeOrder>>,
  TError,
  ResolvePlanChangeOrderMutationVariables,
  TContext
> => {
  const mutationKey = getResolvePlanChangeOrderMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolvePlanChangeOrder>>,
    ResolvePlanChangeOrderMutationVariables
  > = props => {
    const { data } = props ?? {};

    return resolvePlanChangeOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolvePlanChangeOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolvePlanChangeOrder>>
>;
export type ResolvePlanChangeOrderMutationBody =
  BodyType<PlanChangeOrderRequest>;
export type ResolvePlanChangeOrderMutationError = ErrorType<unknown>;
export type ResolvePlanChangeOrderMutationVariables = {
  data: BodyType<PlanChangeOrderRequest>;
};

export const useResolvePlanChangeOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resolvePlanChangeOrder>>,
      TError,
      ResolvePlanChangeOrderMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resolvePlanChangeOrder>>,
  TError,
  ResolvePlanChangeOrderMutationVariables,
  TContext
> => {
  return useMutation(
    getResolvePlanChangeOrderMutationOptions(options),
    queryClient,
  );
};
/**
 * 기간과 가격을 서버 정책으로 계산합니다.
 * @summary 플랜 구매 견적
 */
export const calculatePlanQuote = (
  planQuoteRequest: BodyType<PlanQuoteRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPlanQuoteResponse>(
    {
      url: `/quiz-plans/payment/quote`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: planQuoteRequest,
      signal,
    },
    options,
  );
};

export const getCalculatePlanQuoteMutationKey = () =>
  ['calculatePlanQuote'] as const;

export const getCalculatePlanQuoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calculatePlanQuote>>,
    TError,
    CalculatePlanQuoteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof calculatePlanQuote>>,
  TError,
  CalculatePlanQuoteMutationVariables,
  TContext
> => {
  const mutationKey = getCalculatePlanQuoteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof calculatePlanQuote>>,
    CalculatePlanQuoteMutationVariables
  > = props => {
    const { data } = props ?? {};

    return calculatePlanQuote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CalculatePlanQuoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof calculatePlanQuote>>
>;
export type CalculatePlanQuoteMutationBody = BodyType<PlanQuoteRequest>;
export type CalculatePlanQuoteMutationError = ErrorType<unknown>;
export type CalculatePlanQuoteMutationVariables = {
  data: BodyType<PlanQuoteRequest>;
};

/**
 * @summary 플랜 구매 견적
 */
export const useCalculatePlanQuote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof calculatePlanQuote>>,
      TError,
      CalculatePlanQuoteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof calculatePlanQuote>>,
  TError,
  CalculatePlanQuoteMutationVariables,
  TContext
> => {
  return useMutation(
    getCalculatePlanQuoteMutationOptions(options),
    queryClient,
  );
};
/**
 * 클라이언트 processing 페이지가 Toss pendingUrl 리다이렉트 파라미터를 서버에 전달합니다. 결제 확정 전이므로 payment row 는 만들지 않고 attempt 상태만 PENDING 으로 기록합니다.
 * @summary Antom 비동기 결제 pending 기록
 */
export const recordPaymentPending = (
  recordPaymentPendingRequest: BodyType<RecordPaymentPendingRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPaymentStatusResponse>(
    {
      url: `/quiz-plans/payment/pending`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: recordPaymentPendingRequest,
      signal,
    },
    options,
  );
};

export const getRecordPaymentPendingMutationKey = () =>
  ['recordPaymentPending'] as const;

export const getRecordPaymentPendingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordPaymentPending>>,
    TError,
    RecordPaymentPendingMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordPaymentPending>>,
  TError,
  RecordPaymentPendingMutationVariables,
  TContext
> => {
  const mutationKey = getRecordPaymentPendingMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordPaymentPending>>,
    RecordPaymentPendingMutationVariables
  > = props => {
    const { data } = props ?? {};

    return recordPaymentPending(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordPaymentPendingMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordPaymentPending>>
>;
export type RecordPaymentPendingMutationBody =
  BodyType<RecordPaymentPendingRequest>;
export type RecordPaymentPendingMutationError = ErrorType<unknown>;
export type RecordPaymentPendingMutationVariables = {
  data: BodyType<RecordPaymentPendingRequest>;
};

/**
 * @summary Antom 비동기 결제 pending 기록
 */
export const useRecordPaymentPending = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof recordPaymentPending>>,
      TError,
      RecordPaymentPendingMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof recordPaymentPending>>,
  TError,
  RecordPaymentPendingMutationVariables,
  TContext
> => {
  return useMutation(
    getRecordPaymentPendingMutationOptions(options),
    queryClient,
  );
};
export const resolvePaymentAttempt = (
  quizPlanOrderHashId: string,
  params?: ResolvePaymentAttemptParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<BodyPaymentAttemptResolutionResponse>(
    {
      url: `/quiz-plans/payment/orders/${quizPlanOrderHashId}/resolve-attempt`,
      method: 'POST',
      params,
      signal,
    },
    options,
  );
};

export const getResolvePaymentAttemptMutationKey = () =>
  ['resolvePaymentAttempt'] as const;

export const getResolvePaymentAttemptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolvePaymentAttempt>>,
    TError,
    ResolvePaymentAttemptMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolvePaymentAttempt>>,
  TError,
  ResolvePaymentAttemptMutationVariables,
  TContext
> => {
  const mutationKey = getResolvePaymentAttemptMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolvePaymentAttempt>>,
    ResolvePaymentAttemptMutationVariables
  > = props => {
    const { quizPlanOrderHashId, params } = props ?? {};

    return resolvePaymentAttempt(quizPlanOrderHashId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolvePaymentAttemptMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolvePaymentAttempt>>
>;

export type ResolvePaymentAttemptMutationError = ErrorType<unknown>;
export type ResolvePaymentAttemptMutationVariables = {
  quizPlanOrderHashId: string;
  params?: ResolvePaymentAttemptParams;
};

export const useResolvePaymentAttempt = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resolvePaymentAttempt>>,
      TError,
      ResolvePaymentAttemptMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resolvePaymentAttempt>>,
  TError,
  ResolvePaymentAttemptMutationVariables,
  TContext
> => {
  return useMutation(
    getResolvePaymentAttemptMutationOptions(options),
    queryClient,
  );
};
export const generateOrderId = (
  params: GenerateOrderIdParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyString>(
    {
      url: `/quiz-plans/payment/generate-order-id`,
      method: 'POST',
      params,
      signal,
    },
    options,
  );
};

export const getGenerateOrderIdMutationKey = () => ['generateOrderId'] as const;

export const getGenerateOrderIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateOrderId>>,
    TError,
    GenerateOrderIdMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateOrderId>>,
  TError,
  GenerateOrderIdMutationVariables,
  TContext
> => {
  const mutationKey = getGenerateOrderIdMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateOrderId>>,
    GenerateOrderIdMutationVariables
  > = props => {
    const { params } = props ?? {};

    return generateOrderId(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateOrderIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateOrderId>>
>;

export type GenerateOrderIdMutationError = ErrorType<unknown>;
export type GenerateOrderIdMutationVariables = {
  params: GenerateOrderIdParams;
};

export const useGenerateOrderId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateOrderId>>,
      TError,
      GenerateOrderIdMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateOrderId>>,
  TError,
  GenerateOrderIdMutationVariables,
  TContext
> => {
  return useMutation(getGenerateOrderIdMutationOptions(options), queryClient);
};
/**
 * 선택한 플랜에 대한 가격 견적을 계산합니다.
 * @summary 플랜 가격 견적 계산
 */
export const calculateEstimate = (
  priceCalculationRequest: BodyType<PriceCalculationRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPriceCalculationResponse>(
    {
      url: `/quiz-plans/payment/estimate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: priceCalculationRequest,
      signal,
    },
    options,
  );
};

export const getCalculateEstimateMutationKey = () =>
  ['calculateEstimate'] as const;

export const getCalculateEstimateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calculateEstimate>>,
    TError,
    CalculateEstimateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof calculateEstimate>>,
  TError,
  CalculateEstimateMutationVariables,
  TContext
> => {
  const mutationKey = getCalculateEstimateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof calculateEstimate>>,
    CalculateEstimateMutationVariables
  > = props => {
    const { data } = props ?? {};

    return calculateEstimate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CalculateEstimateMutationResult = NonNullable<
  Awaited<ReturnType<typeof calculateEstimate>>
>;
export type CalculateEstimateMutationBody = BodyType<PriceCalculationRequest>;
export type CalculateEstimateMutationError = ErrorType<unknown>;
export type CalculateEstimateMutationVariables = {
  data: BodyType<PriceCalculationRequest>;
};

/**
 * @summary 플랜 가격 견적 계산
 */
export const useCalculateEstimate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof calculateEstimate>>,
      TError,
      CalculateEstimateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof calculateEstimate>>,
  TError,
  CalculateEstimateMutationVariables,
  TContext
> => {
  return useMutation(getCalculateEstimateMutationOptions(options), queryClient);
};
/**
 * 현재 플랜을 기준으로 연장 또는 업그레이드 기간과 가격을 계산합니다.
 * @summary 플랜 변경 견적
 */
export const calculatePlanChangeQuote = (
  planChangeQuoteRequest: BodyType<PlanChangeQuoteRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPlanChangeQuoteResponse>(
    {
      url: `/quiz-plans/payment/estimate/plan-change`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: planChangeQuoteRequest,
      signal,
    },
    options,
  );
};

export const getCalculatePlanChangeQuoteMutationKey = () =>
  ['calculatePlanChangeQuote'] as const;

export const getCalculatePlanChangeQuoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calculatePlanChangeQuote>>,
    TError,
    CalculatePlanChangeQuoteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof calculatePlanChangeQuote>>,
  TError,
  CalculatePlanChangeQuoteMutationVariables,
  TContext
> => {
  const mutationKey = getCalculatePlanChangeQuoteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof calculatePlanChangeQuote>>,
    CalculatePlanChangeQuoteMutationVariables
  > = props => {
    const { data } = props ?? {};

    return calculatePlanChangeQuote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CalculatePlanChangeQuoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof calculatePlanChangeQuote>>
>;
export type CalculatePlanChangeQuoteMutationBody =
  BodyType<PlanChangeQuoteRequest>;
export type CalculatePlanChangeQuoteMutationError = ErrorType<unknown>;
export type CalculatePlanChangeQuoteMutationVariables = {
  data: BodyType<PlanChangeQuoteRequest>;
};

/**
 * @summary 플랜 변경 견적
 */
export const useCalculatePlanChangeQuote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof calculatePlanChangeQuote>>,
      TError,
      CalculatePlanChangeQuoteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof calculatePlanChangeQuote>>,
  TError,
  CalculatePlanChangeQuoteMutationVariables,
  TContext
> => {
  return useMutation(
    getCalculatePlanChangeQuoteMutationOptions(options),
    queryClient,
  );
};
/**
 * 퀴즈 플랜 결제를 위한 주문을 생성합니다.
 * @summary 퀴즈 플랜 주문 생성
 */
export const createQuizPlanOrder = (
  createQuizPlanOrderRequest: BodyType<CreateQuizPlanOrderRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizPlanOrderResponse>(
    {
      url: `/quiz-plans/payment/create-order`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createQuizPlanOrderRequest,
      signal,
    },
    options,
  );
};

export const getCreateQuizPlanOrderMutationKey = () =>
  ['createQuizPlanOrder'] as const;

export const getCreateQuizPlanOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuizPlanOrder>>,
    TError,
    CreateQuizPlanOrderMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuizPlanOrder>>,
  TError,
  CreateQuizPlanOrderMutationVariables,
  TContext
> => {
  const mutationKey = getCreateQuizPlanOrderMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuizPlanOrder>>,
    CreateQuizPlanOrderMutationVariables
  > = props => {
    const { data } = props ?? {};

    return createQuizPlanOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuizPlanOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuizPlanOrder>>
>;
export type CreateQuizPlanOrderMutationBody =
  BodyType<CreateQuizPlanOrderRequest>;
export type CreateQuizPlanOrderMutationError = ErrorType<unknown>;
export type CreateQuizPlanOrderMutationVariables = {
  data: BodyType<CreateQuizPlanOrderRequest>;
};

/**
 * @summary 퀴즈 플랜 주문 생성
 */
export const useCreateQuizPlanOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createQuizPlanOrder>>,
      TError,
      CreateQuizPlanOrderMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createQuizPlanOrder>>,
  TError,
  CreateQuizPlanOrderMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateQuizPlanOrderMutationOptions(options),
    queryClient,
  );
};
/**
 * 토스페이먼츠 결제 승인 콜백을 처리하고 워크스페이스를 생성합니다.
 * @summary 결제 승인 콜백 처리
 */
export const handlePaymentSuccess = (
  params: HandlePaymentSuccessParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizPlanPaymentResponse>(
    {
      url: `/quiz-plans/payment/toss-callback/success`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getHandlePaymentSuccessQueryKey = (
  params?: HandlePaymentSuccessParams,
) => {
  return [
    `/quiz-plans/payment/toss-callback/success`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHandlePaymentSuccessQueryOptions = <
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHandlePaymentSuccessQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof handlePaymentSuccess>>
  > = ({ signal }) => handlePaymentSuccess(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof handlePaymentSuccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HandlePaymentSuccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof handlePaymentSuccess>>
>;
export type HandlePaymentSuccessQueryError = ErrorType<unknown>;

export function useHandlePaymentSuccess<
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof handlePaymentSuccess>>,
          TError,
          Awaited<ReturnType<typeof handlePaymentSuccess>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useHandlePaymentSuccess<
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof handlePaymentSuccess>>,
          TError,
          Awaited<ReturnType<typeof handlePaymentSuccess>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useHandlePaymentSuccess<
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 결제 승인 콜백 처리
 */

export function useHandlePaymentSuccess<
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getHandlePaymentSuccessQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getHandlePaymentSuccessSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHandlePaymentSuccessQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof handlePaymentSuccess>>
  > = ({ signal }) => handlePaymentSuccess(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof handlePaymentSuccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type HandlePaymentSuccessSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof handlePaymentSuccess>>
>;
export type HandlePaymentSuccessSuspenseQueryError = ErrorType<unknown>;

export function useHandlePaymentSuccessSuspense<
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useHandlePaymentSuccessSuspense<
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useHandlePaymentSuccessSuspense<
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 결제 승인 콜백 처리
 */

export function useHandlePaymentSuccessSuspense<
  TData = Awaited<ReturnType<typeof handlePaymentSuccess>>,
  TError = ErrorType<unknown>,
>(
  params: HandlePaymentSuccessParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof handlePaymentSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getHandlePaymentSuccessSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 클라이언트가 결제 진행 상태를 주기적으로 조회합니다. READY/PENDING 은 spinner 유지, APPROVED 면 완료 페이지로, FAILED 면 에러 처리.
 * @summary 결제 상태 폴링 (Antom 비동기 결제용)
 */
export const getPaymentStatus = (
  params: GetPaymentStatusParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPaymentStatusResponse>(
    { url: `/quiz-plans/payment/status`, method: 'GET', params, signal },
    options,
  );
};

export const getGetPaymentStatusQueryKey = (
  params?: GetPaymentStatusParams,
) => {
  return [`/quiz-plans/payment/status`, ...(params ? [params] : [])] as const;
};

export const getGetPaymentStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPaymentStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentStatus>>
  > = ({ signal }) => getPaymentStatus(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPaymentStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentStatus>>
>;
export type GetPaymentStatusQueryError = ErrorType<unknown>;

export function useGetPaymentStatus<
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentStatus>>,
          TError,
          Awaited<ReturnType<typeof getPaymentStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentStatus<
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentStatus>>,
          TError,
          Awaited<ReturnType<typeof getPaymentStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentStatus<
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 결제 상태 폴링 (Antom 비동기 결제용)
 */

export function useGetPaymentStatus<
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPaymentStatusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPaymentStatusSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPaymentStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentStatus>>
  > = ({ signal }) => getPaymentStatus(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPaymentStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetPaymentStatusSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentStatus>>
>;
export type GetPaymentStatusSuspenseQueryError = ErrorType<unknown>;

export function useGetPaymentStatusSuspense<
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentStatusSuspense<
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentStatusSuspense<
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 결제 상태 폴링 (Antom 비동기 결제용)
 */

export function useGetPaymentStatusSuspense<
  TData = Awaited<ReturnType<typeof getPaymentStatus>>,
  TError = ErrorType<unknown>,
>(
  params: GetPaymentStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPaymentStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPaymentStatusSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 퀴즈 플랜 주문 정보를 조회합니다. READY 상태의 주문만 조회 가능합니다.
 * @summary 퀴즈 플랜 주문 조회
 */
export const getQuizPlanOrder = (
  params: GetQuizPlanOrderParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizPlanOrderResponse>(
    { url: `/quiz-plans/payment/order`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizPlanOrderQueryKey = (
  params?: GetQuizPlanOrderParams,
) => {
  return [`/quiz-plans/payment/order`, ...(params ? [params] : [])] as const;
};

export const getGetQuizPlanOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizPlanOrderQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizPlanOrder>>
  > = ({ signal }) => getQuizPlanOrder(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizPlanOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizPlanOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizPlanOrder>>
>;
export type GetQuizPlanOrderQueryError = ErrorType<unknown>;

export function useGetQuizPlanOrder<
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizPlanOrder>>,
          TError,
          Awaited<ReturnType<typeof getQuizPlanOrder>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizPlanOrder<
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizPlanOrder>>,
          TError,
          Awaited<ReturnType<typeof getQuizPlanOrder>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizPlanOrder<
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 퀴즈 플랜 주문 조회
 */

export function useGetQuizPlanOrder<
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizPlanOrderQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizPlanOrderSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizPlanOrderQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizPlanOrder>>
  > = ({ signal }) => getQuizPlanOrder(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizPlanOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizPlanOrderSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizPlanOrder>>
>;
export type GetQuizPlanOrderSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizPlanOrderSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizPlanOrderSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizPlanOrderSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 퀴즈 플랜 주문 조회
 */

export function useGetQuizPlanOrderSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlanOrder>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlanOrderParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOrder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizPlanOrderSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 사용자의 국가에 맞는 플랜 가격 목록을 조회합니다. 결제 가능 여부는 견적과 주문 생성 시 검증합니다.
 * @summary 사용자 플랜 가격 조회
 */
export const getUserPlanAvailability = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyGetUserPlanAvailabilityResponse>(
    { url: `/quiz-plans/availability`, method: 'GET', signal },
    options,
  );
};

export const getGetUserPlanAvailabilityQueryKey = () => {
  return [`/quiz-plans/availability`] as const;
};

export const getGetUserPlanAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserPlanAvailability>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserPlanAvailabilityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserPlanAvailability>>
  > = ({ signal }) => getUserPlanAvailability(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserPlanAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserPlanAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPlanAvailability>>
>;
export type GetUserPlanAvailabilityQueryError = ErrorType<unknown>;

export function useGetUserPlanAvailability<
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPlanAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPlanAvailability>>,
          TError,
          Awaited<ReturnType<typeof getUserPlanAvailability>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserPlanAvailability<
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPlanAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPlanAvailability>>,
          TError,
          Awaited<ReturnType<typeof getUserPlanAvailability>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserPlanAvailability<
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPlanAvailability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 사용자 플랜 가격 조회
 */

export function useGetUserPlanAvailability<
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPlanAvailability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserPlanAvailabilityQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUserPlanAvailabilitySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getUserPlanAvailability>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserPlanAvailabilityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserPlanAvailability>>
  > = ({ signal }) => getUserPlanAvailability(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getUserPlanAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetUserPlanAvailabilitySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPlanAvailability>>
>;
export type GetUserPlanAvailabilitySuspenseQueryError = ErrorType<unknown>;

export function useGetUserPlanAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserPlanAvailability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserPlanAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserPlanAvailability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserPlanAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserPlanAvailability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 사용자 플랜 가격 조회
 */

export function useGetUserPlanAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getUserPlanAvailability>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserPlanAvailability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserPlanAvailabilitySuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
